/* TRIAL & FLORA — mounts the generated hero art (see trial-flora-art.js).
   Re-mounts on theme-editor section reloads. */
(function () {
  function mount(root) {
    /* TF_ART is a top-level const in trial-flora-art.js — script-scoped, not on window */
    if (typeof TF_ART === "undefined") return;
    var nodes = root.querySelectorAll("[data-tf-hero-art]");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].innerHTML = TF_ART.hero(nodes[i].getAttribute("data-art-theme") || "light");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      mount(document);
    });
  } else {
    mount(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    mount(e.target);
  });
})();
